<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color="blue"
           data-image="static/img/background/architecture-barge-bay-beach-161764.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#">
                  <div class="card" data-background="color" data-color="blue">
                    <div style="text-align: center; padding-top: 20px; padding-bottom: 10px;">
                      <a href="https://authentic.net"><img src="static/img/authentic_net_lt.png" width="200" alt="Authentic.net"></a>
                    </div>
                    <div class="card-header">
                      <h3 class="card-title">Login</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Email Address or Phone Number</label>
                        <input
                          type="text"
                          name="emailphone"
                          v-model="model.emailphone"
                          v-validate="modelValidations.emailphone"
                          placeholder="user@email.com / 5556667777"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="email.invalid">
                          {{ getError('emailphone') }}
                        </small>
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit" v-if="!loading" @click.prevent="" id="submit-btn" class="btn btn-fill btn-wd ">Submit</button>
                      <button type="button" v-if="loading" class="btn btn-wd " disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Submit
                      </button>
                      <div class="signup-link">
                        <router-link to="/signup">
                          No Authentic.net Account? Sign Up!
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; Copyright 2019 Authentic.net
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/architecture-barge-bay-beach-161764.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Sign Up</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import store from '@/store'
  import firebase from 'firebase'
  import db from '@/components/firebase/init'

  export default {
    computed: {
      ...mapFields(['email', 'password'])
    },
    data () {
      return {
        loading: false,
        recaptcha: {
          verifier: null,
          confirmationResult: null,
          widgetId: null
        },
        user: {
          email: '',
          name: '',
          id: '',
          accountId: ''
        },
        model: {
          emailphone: ''
        },
        modelValidations: {
          emailphone: {
            required: true
          }
        }
      }
    },
    methods: {
      init () {
        if (this.$route.query.logout) this.logout()
        this.setupRecaptcha()
      },
      setupRecaptcha () {
        const self = this

        // Start Firebase invisible reCAPTCHA verifier
        this.recaptcha.verifier = new firebase.auth.RecaptchaVerifier('submit-btn', {
          size: 'invisible',
          callback: response => {
            // reCAPTCHA solved, allow to proceed
            console.log('solved ' + response)
            this.login()
          },
          error: () => {
            swal.fire({
              title: 'Error',
              text: 'There was a problem validating captcha',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          }
        })

        this.recaptcha.verifier.render().then((widgetId) => {
          this.recaptcha.widgetId = widgetId
        })
      },
      resetRecaptcha () {
        window.grecaptcha.reset(this.recaptcha.widgetId)
      },
      login () {
        if (this.model.emailphone.includes('@')) this.loginEmail()
        else this.loginPhone()
      },
      async loginEmail () {
        let signingMethods = await firebase.auth().fetchSignInMethodsForEmail(this.model.emailphone)
        if (signingMethods.indexOf('emailLink') === -1) {
          swal.fire({
            title: 'Error',
            text: 'An account with that email address was not found.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        } else {
          let actionCodeSettings = {
            // URL you want to redirect back to. The domain (www.example.com) for this
            // URL must be whitelisted in the Firebase Console.
            url: process.env.APP_ROOT_URL + '/admin/dashboard',
            // This must be true.
            handleCodeInApp: true
          }
          firebase.auth().sendSignInLinkToEmail(this.model.emailphone, actionCodeSettings)
          .then(() => {
            window.localStorage.setItem('emailForSignIn', this.model.emailphone)
            swal.fire({
              imageUrl: 'static/img/auth_logo_small_2.png',
              imageWidth: 84,
              imageHeight: 84,
              imageAlt: 'Authentic.net logo',
              title: `Login Link Sent`,
              text: `Please check your email and click the provided link to login.`,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill'
            })
            // The link was successfully sent. Inform the user.
            // Save the email locally so you don't need to ask the user for it again
            // if they open the link on the same device.
            // window.localStorage.setItem('emailForSignIn', email);
          })
          .catch((error) => {
            // Some error occurred, you can inspect the code: error.code
            console.log(error)
          })
        }
      },
      async loginPhone () {
        let phone = '+1' + this.model.emailphone
        let phoneUserExists = firebase.functions().httpsCallable('phoneUserExists')
        let existsResult = await phoneUserExists({ phoneNumber: phone })
        if (!existsResult.data.success) {
          swal.fire({
            title: 'Error',
            text: 'Phone number not found.',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.resetRecaptcha()
        } else {
          let recaptchaVerifier = this.recaptcha.verifier
          firebase.auth().signInWithPhoneNumber(phone, recaptchaVerifier).then(confirmationResult => {
            console.log('code sent, result:')
            console.log(confirmationResult)
            this.requestSmsCode(confirmationResult)
            // return confirmationResult
          })
          .catch(error => {
            console.log('error sending phone to firebase')
            console.log(error)
          })
        }
      },
      login2 () {
        this.loading = true
        firebase.auth().signInWithEmailAndPassword(this.model.email, this.model.password)
        .then(cred => {
          this.user.email = cred.user.email
          this.user.id = cred.user.uid
          return db.collection('users').doc(cred.user.uid).get()
        })
        .then(doc => {
          this.user.name = doc.data().name
          this.user.accountId = doc.data().accountId
          store.setUser(this.user)
          return axios.get(`${this.apiBaseUrl}getClientIp`)
        })
        .then(response => {
          if (!response.data.success) return false
          else return db.collection('users').doc(this.user.id).update({ lastLoginIp: response.data.ipAddress })
        })
        .then((docRef) => {
          return swal.fire({
            title: 'SMS Verification',
            text: 'Please provide your mobile number:',
            type: 'question',
            input: 'text',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false,
            inputPlaceholder: 'Mobile Number'
          })
        })
        .then((result) => {
          console.log('phone input')
          console.log(result)
          let phone = result.value
          let recaptchaVerifier = this.recaptcha.verifier
          firebase.auth().signInWithPhoneNumber(phone, recaptchaVerifier).then(confirmationResult => {
            console.log('code sent, result:')
            console.log(confirmationResult)
            this.requestSmsCode(confirmationResult)
            // return confirmationResult
          })
          .catch(error => {
            console.log('error sending phone to firebase')
            console.log(error)
          })
        })
        // .then((confirmationResult) => {
        //   console.log('confirmationResult')
        //   console.log(confirmationResult)
        //   this.recaptcha.confirmationResult = confirmationResult
        //   return swal.fire({
        //     title: 'SMS Verification',
        //     text: 'Please provide the code sent to your mobile device:',
        //     type: 'question',
        //     input: 'text',
        //     showCancelButton: true,
        //     confirmButtonClass: 'btn btn-success btn-fill',
        //     cancelButtonClass: 'btn btn-danger btn-fill',
        //     buttonsStyling: false,
        //     inputPlaceholder: 'Mobile Number'
        //   })
        // })
        // .then(result => {
        //   console.log(result)
        //   let code = result.value
        //   return this.recaptcha.confirmationResult.confirm(code)
        // })
        // .then(result => {
        //   console.log('recaptcha confirmation result')
        //   console.log(result)
        //   return true
        // })
        // .then(() => {
        //   this.$router.replace(this.$route.query.redirect || { name: 'Dashboard' })
        // })
        .catch(err => {
          console.log(err)
          swal.fire({
            title: 'Error',
            text: err.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
          this.resetRecaptcha()
        })
      },
      requestSmsCode (confirmationResult) {
        console.log('in requestSmsCode')
        console.log(confirmationResult)
        swal.fire({
          imageUrl: 'static/img/auth_logo_small_2.png',
          imageWidth: 84,
          imageHeight: 84,
          imageAlt: 'Authentic.net logo',
          title: 'SMS Verification',
          text: 'Please provide the code sent to your mobile device:',
          input: 'text',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false,
          inputPlaceholder: 'Mobile Number'
        })
        .then(inputResult => {
          confirmationResult.confirm(inputResult.value)
          .then(result => {
            this.$router.replace(this.$route.query.redirect || { name: 'Dashboard' })
          })
          .catch(error => {
            console.log(error)
            swal.fire({
              title: 'Error',
              text: error.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          })
        })
      },
      logout () {
        firebase.auth().signOut().then(() => {

        })
        .catch((error) => {
          var errMsg = error.message
          console.log(error)
          swal.fire({
            title: 'Error',
            text: errMsg,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
          this.loading = false
          this.resetRecaptcha()
        })
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeDestroy () {
      this.closeMenu()
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.signup-link {
  margin-top: 40px;
}
.signup-link a {
  color: #66615b;
}
.signup-link a:hover {
  color: #337ab7;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue